import React from 'react';
import { FormLabel, Typography, Box } from '@mui/material';

const MultiLevelFormLabel = (props: { title: string; message: string; for: string }): JSX.Element => {
  return (
    <Box sx={{ mb: '8px' }}>
      <FormLabel htmlFor={props.for} sx={{ mb: '4px' }}>
        {props.title}
      </FormLabel>
      <Typography sx={{ fontSize: '.75rem' }}>{props.message}</Typography>
    </Box>
  );
};

export default MultiLevelFormLabel;
